import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

const Section = css`
  border-bottom: #5c6874 1px solid;
  padding-bottom: ${({ theme }) => theme.x5space * 10}px;
  margin-bottom: ${({ theme }) => theme.x4spacePx}px;
`;

export const DiversificationWrapper = styled.section`
  ${media.mdUp`
		padding-top: ${({ theme }) => theme.x6spacePx}px;
		padding-bottom: ${({ theme }) => theme.x6spacePx}px;
		border-top: 30px solid #4b5965;
	`}
  ${media.smDown`
		> h1 {
			display: none;
		}
	`};
`;

export const HoldingsDiversificationWrapper = styled.section`
  ${Section};
`;

export const ScrollPane = styled.div`
  ${media.smDown`
		overflow-y: hidden;
		overflow-x: auto;
	`};
`;
